import { hooks } from "./hookactions"
let actions = {}
export let QUTOfferingPos = { hooks, actions }
